import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { useConfirmDialog, useDbRestore, useError } from '@ztechapps/common.hook'
import { EnvironmentEnum } from '@ztechapps/common.contract'
import { ShowIf } from '@ztechapps/webui.util'
import { appSettings } from '../../../config/app-settings'

export default function DbRestore() {
  const [onRestore, { loading, error }] = useDbRestore()
  const { confirm } = useConfirmDialog({
    title: 'Restore Database',
    text: 'Restoring database is ok, because you are NOT IN PRODUCTION ENVIRONMENT anyway. Do you wish to continue?',
  })

  useError(error)

  const onClick = async () => {
    await confirm(() => onRestore())
  }

  // Fails closed: an unknown environment hides the button. Restoring wipes the
  // database on every environment that permits it, so "not proven safe" must
  // read as unsafe rather than fall through to visible.
  return (
    <ShowIf condition={!!appSettings.nodeEnv && appSettings.nodeEnv !== EnvironmentEnum.Production}>
      <BusyButton
        text="Restore Db"
        variant="warning"
        onClick={onClick}
        isBusy={loading}
        title="You are NOT in PRODUCTION, so you can restore the database."
      />
    </ShowIf>
  )
}
